(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("VdtnetTable", [], factory);
	else if(typeof exports === 'object')
		exports["VdtnetTable"] = factory();
	else
		root["VdtnetTable"] = factory();
})(self, function() {
return 